<template>
  <div id="template">
    <Breadcrumb></Breadcrumb>
    <div class="form-body">
      <el-form
        ref="queryForm"
        :model="queryParams"
        label-width="80px"
        style="padding: 0 5px"
      >
        <el-row :gutter="20">
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="编码类型：">
                <el-select
                  clearable
                  v-model="queryParams.productCodeType"
                  placeholder="请选择编码类型"
                  class="input"
                  size="small"
                >
                  <el-option
                    v-for="(value, key, index) in dictData['productCodeType']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                    >{{ value.label }}
                  </el-option>
                </el-select>
              </el-form-item>
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="产商代码：">
                <el-input
                  size="small"
                  v-model="queryParams.factoryCode"
                  placeholder="请输入内容"
                ></el-input>
              </el-form-item></div
          ></el-col>
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="状态：" prop="dateValue">
                <el-select
                  clearable
                  v-model="queryParams.isUse"
                  placeholder="请选择状态"
                  class="input"
                  size="small"
                >
                  <el-option
                    v-for="(value, key, index) in dictData[
                      'sys_normal_disable'
                    ]"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                    >{{ value.label }}
                  </el-option>
                </el-select>
                <div style="text-align: right; margin: auto; padding-top: 10px">
                  <el-button size="small" type="primary" @click="getList"
                    >搜索</el-button
                  >
                  <el-button size="small" @click="resetForm">重置</el-button>
                </div>
              </el-form-item>
            </div></el-col
          >
        </el-row>
      </el-form>
    </div>
    <div class="form-body">
      <div class="form-body-header">
        <div class="left" style="margin: 0 16px 0 0">
          <el-button size="small" type="primary" @click="handleAddEan"
            >生成EAN</el-button
          >
        </div>
        <div class="left">
          <el-button size="small" type="primary" @click="handleAddUpc"
            >生成UPC</el-button
          >
        </div>
        <div class="right">
          <pagination
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
          />
        </div>
      </div>
      <el-table
        id="outTable"
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          prop="productCodeType"
          label="编码类型"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="flagCode"
          label="旗码"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="factoryCode"
          label="厂商代码"
          align="center"
        ></el-table-column>
        <el-table-column prop="totalNum" label="生成条数" align="center">
          <template slot-scope="scope">
            <div>
              <span
                @click="handleShowDetail(scope.row)"
                style="color: #409eff; cursor: pointer"
                >{{ scope.row.totalNum }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="useNum"
          label="已使用条数"
          align="center"
        ></el-table-column>
        <el-table-column prop="isUse" label="状态" align="center">
          <template slot-scope="scope">
            <span>{{ dictMap["sys_normal_disable"][scope.row.isUse] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="operNo"
          label="操作人"
          align="center"
        ></el-table-column>
        <el-table-column prop="tTime" label="操作时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column prop="handel" label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="handleOperateStatus(scope.row)"
              >{{ scope.row.isUse == "1" ? "设为失效" : "取消失效" }}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID" v-if="false"></el-table-column>
      </el-table>

      <pagination
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="生成EAN"
      width="600px"
      :visible.sync="eanVisible"
    >
      <div>
        <div style="font-size: 14px; padding: 0 0 0 8px; margin: 8px 0">
          <i class="el-icon-info"></i> 还可以生成 {{ maxNum }} 条编码
        </div>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          size="small"
          label-width="100px"
        >
          <el-form-item prop="flagCode" label="旗码：">
            <el-select
              clearable
              v-model="form.flagCode"
              placeholder="请选择旗码"
              class="input"
              size="small"
              style="width: 360px"
            >
              <el-option
                v-for="(value, key, index) in dictData['eanFlagCode']"
                :key="index"
                :label="value.label"
                :value="value.value"
                >{{ value.label }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="厂商代码：" prop="factoryCode">
            <el-input
              style="width: 360px; margin: 0 16px 0 0"
              v-model="form.factoryCode"
              placeholder="请输入厂商代码"
            ></el-input>
            <el-button @click="handleCreateFactroyCode('EAN')" type="text"
              >自动生成</el-button
            >
          </el-form-item>
          <el-form-item label="生成数量：" prop="totalNum">
            <el-input
              style="width: 360px"
              v-model="form.totalNum"
              placeholder="请输入生成数量"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="small" @click="eanVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handleCreateEan"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="生成UPC"
      width="600px"
      :visible.sync="upcVisible"
    >
      <div>
        <div style="font-size: 14px; padding: 0 0 0 8px; margin: 8px 0">
          <i class="el-icon-info"></i> 还可以生成 {{ maxNum }} 条编码
        </div>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          size="small"
          label-width="100px"
        >
          <el-form-item prop="flagCode" label="旗码：">
            <el-select
              clearable
              v-model="form.flagCode"
              placeholder="请选择旗码"
              class="input"
              size="small"
              style="width: 360px"
            >
              <el-option
                v-for="(value, key, index) in dictData['upcFlagCode']"
                :key="index"
                :label="value.label"
                :value="value.value"
                >{{ value.label }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="厂商代码：" prop="factoryCode">
            <el-input
              style="width: 360px; margin: 0 16px 0 0"
              v-model="form.factoryCode"
              placeholder="请输入厂商代码"
            ></el-input>
            <el-button @click="handleCreateFactroyCode('UPC')" type="text"
              >自动生成</el-button
            >
          </el-form-item>
          <el-form-item label="生成数量：" prop="totalNum">
            <el-input
              style="width: 360px"
              v-model="form.totalNum"
              placeholder="请输入生成数量"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="small" @click="upcVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handleCreateUpc"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="编码详情"
      width="800px"
      :visible.sync="detailVisible"
    >
      <div style="height: 450px; overflow-y: auto">
        <el-table
          id="outTable"
          ref="multipleTable"
          :data="codeData"
          style="width: 100%"
        >
          <el-table-column
            prop="productCodeType"
            label="编码类型"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="flagCode"
            label="旗码"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="factoryCode"
            label="厂商代码"
            align="center"
          ></el-table-column>
          <el-table-column
            width="200px"
            prop="productCode"
            label="商品编码"
            align="center"
          ></el-table-column>
          <el-table-column prop="productCodeStatus" label="状态" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.productCodeStatus == "01" ? "未使用" : "已使用"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="ID" v-if="false"></el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button size="small" type="primary" @click="detailVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from "@/components/common/Breadcrumb";
import { listCode, listDet, getMaxNum , addCode , editFlag } from "@/api/order/code";
import { mapGetters } from "vuex";

export default {
  name: "codeManage",
  components: { Breadcrumb },
  data() {
    return {
      selectValue1: "",
      total: 0,
      currentPage: 1,
      pickerOptions: {},
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        productCodeType: '',
        factoryCode: '',
        isUse: null,
      },
      form: {
        flagCode: '',
        factoryCode: '',
        productCodeType: '',
        totalNum: ''
      },
      dateValue: [],
      pickerOptions: {},
      tableData: [],
      eanVisible: false,
      upcVisible: false,
      rules: {
        flagCode: [{required: true, message: '请选择旗码', trigger: 'change'}],
        factoryCode: [{required: true, message: '请输入工厂代码', trigger: 'blur'}],
        totalNum: [{required: true, message: '请输入生成数量', trigger: 'blur'}],
      },
      maxNum: 0,
      detailVisible: false,
      codeData: []
    };
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  watch: {
  },
  created() {
    this.getList();
  },
  methods: {
    getList(){
      // if(this.dateValue && this.dateValue.length > 0){
      //   this.form.beginTime = this.dateValue[0]
      //   this.form.endTime = this.dateValue[1]
      // } else{
      //   this.form.beginTime = null
      //   this.form.endTime = null
      // }
      listCode(this.queryParams).then((result)=>{
        this.tableData = result.rows
        this.total = result.total
      })
    },
    resetForm(){
       this.queryParams = Object.assign(this.queryParams,{
        productCodeType: '',
        factoryCode: '',
        isUse: null,
      })
    },
    async handleAddEan(){
      this.eanVisible = true
      let result = await getMaxNum({productCodeType: 'EAN'})
      this.maxNum = result.data
      this.form = {
        flagCode: '',
        factoryCode: '',
        productCodeType: '',
        totalNum: '',
      }
    },
    async handleAddUpc(){
      this.upcVisible = true
      let result = await getMaxNum({productCodeType: 'UPC'})
      this.maxNum = result.data
      this.form = {
        flagCode: '',
        factoryCode: '',
        productCodeType: '',
        totalNum: '',
      }
    },
    async handleShowDetail(row){
      let result = await listDet({codeKey: row.codeKey})//codeKey编码
      this.codeData = result.rows
      this.detailVisible = true
    },
    handleCreateEan(){
      this.form.productCodeType = 'EAN'
      if(this.form.factoryCode.length !== 6){
        this.msgError('EAN编码只能6位')
        return
      }

      if(Number(this.maxNum) < Number(this.form.totalNum)){
        this.msgError('不能超过最大编码数')
        return
      }


       this.$refs["form"].validate(valid => {
        if(valid){
          addCode(this.form).then((res) => {
            if (res.code == 200) {
              this.msgSuccess("EAN生成成功");
              this.getList()
              this.eanVisible = false
            }
          }).catch(err => {
          });
        } else{
          this.$message.warning("信息填写不完整！");
        }

      })
    },
    handleCreateUpc(){
      this.form.productCodeType = 'UPC'
      if(this.form.factoryCode.length !== 5){
        this.msgError('UPC编码只能5位')
        return
      }
      
      if(Number(this.maxNum) < Number(this.form.totalNum)){
        this.msgError('不能超过最大编码数')
        return
      }
       this.$refs["form"].validate(valid => {
        if(valid){
          addCode(this.form).then((res) => {
            if (res.code == 200) {
              this.msgSuccess("UPC生成成功");
              this.getList()
              this.upcVisible = false
            }
          }).catch(err => {
          });
        } else{
          this.$message.warning("信息填写不完整！");
        }

      })
    },
    handleCreateFactroyCode(type){
       var code = ('00000' + Math.floor(Math.random() * 99999)).slice(-5)
       if(type == 'EAN'){
         code = ('000000' + Math.floor(Math.random() * 999999)).slice(-6)
       }
       this.form.factoryCode = code
    },
    handleOperateStatus(row){
      editFlag({
        codeKey: row.codeKey,
        isUse: row.isUse == '1' ? '0' : '1'
      })
      this.getList()
      this.msgSuccess("操作成功")
    }
  },
  mounted() {},
};
</script>

<style scoped>
@import "../../../assets/css/product.css";
#ready-release {
  width: 100%;
}
.detailForm {
  padding-top: 5px;
  margin-left: 85px;
  width: 50%;
  height: auto;
  margin-bottom: 8px;
}
.detailForm .el-form-item,
.sea_cont {
  margin-bottom: 10px !important;
}
.double_item .el-form-item {
  margin-bottom: 0px !important;
}
.scro >>> .el-scrollbar__wrap {
  overflow-x: hidden;
}
.form-content {
  background: #ffffff;
}
</style>
